import React, { useState } from "react";
import styles from "./styles.module.css";

function TotalReceivedCard({ summary }) {
    const [open, setOpen] = useState(false);

    if (!summary) {
        return (
            <div className={styles.card}>
                <p className={styles.loading}>Carregando...</p>
            </div>
        );
    }

    return (
        <div className={styles.card} onClick={() => setOpen(!open)}>

            {!open && (
                <div className={styles.item}>
                    <span className={styles.label}>Total Recebido</span>
                    <span className={`${styles.value} ${styles.highlight}`}>
                        R$ {summary.month.toFixed(2)}
                    </span>
                    <span className={styles.chevron}>▾</span>
                </div>
            )}

            <div className={`${styles.grid} ${open ? styles.gridOpen : ""}`}>
                <div className={styles.gridInner}>

                    <div className={styles.headerRow}>
                        <h3 className={styles.title}>Total Recebido</h3>
                        <span className={`${styles.chevron} ${styles.chevronOpen}`}>▾</span>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.label}>Mês atual</span>
                        <span className={`${styles.value} ${styles.highlight}`}>
                            R$ {summary.month.toFixed(2)}
                        </span>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.label}>Resumo do semestre</span>
                        <span className={styles.value}>
                            R$ {summary.semester.toFixed(2)}
                        </span>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.label}>Total anual</span>
                        <span className={styles.value}>
                            R$ {summary.year.toFixed(2)}
                        </span>
                    </div>

                </div>
            </div>

        </div>
    );
}

export default TotalReceivedCard;